(function () {
  'use strict';

  var settings = window.themeSettings || {};

  /* ---------------- money formatting ---------------- */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------------- progress rail + scroll spy + sticky bar ---------------- */
  function initRailAndSpy() {
    var productSections = Array.prototype.slice.call(document.querySelectorAll('.product-chapter[data-product-section]'));
    if (!productSections.length) return;

    var showRail = document.body.getAttribute('data-show-rail') === 'true';
    var rail = null;

    if (showRail) {
      rail = document.createElement('div');
      rail.className = 'rail';
      productSections.forEach(function (section) {
        var a = document.createElement('a');
        a.href = '#' + section.id;
        a.dataset.target = section.id;
        var tip = document.createElement('span');
        tip.className = 'tip';
        tip.textContent = (section.dataset.railTag || '') + ' — ' + (section.dataset.railLabel || '');
        a.appendChild(tip);
        rail.appendChild(a);
      });
      document.body.appendChild(rail);
    }

    var stickybar = document.getElementById('stickybar');
    var sbName = document.getElementById('sb-name');
    var sbPrice = document.getElementById('sb-price');
    var sbAddBtn = document.getElementById('sb-add-btn');
    var activeForm = null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var section = entry.target;
          if (rail) {
            var links = rail.querySelectorAll('a');
            links.forEach(function (a) {
              a.classList.toggle('active', a.dataset.target === section.id);
            });
          }
          if (sbName && sbPrice) {
            sbName.textContent = section.dataset.railLabel || '';
            var priceEl = section.querySelector('[data-price]');
            if (priceEl) sbPrice.textContent = priceEl.textContent;
          }
          activeForm = section.querySelector('[data-product-form]');
        }
      });
    }, { threshold: 0.5 });
    productSections.forEach(function (s) { io.observe(s); });

    if (sbAddBtn) {
      sbAddBtn.addEventListener('click', function () {
        if (activeForm) {
          activeForm.requestSubmit ? activeForm.requestSubmit() : activeForm.submit();
        } else {
          window.location.href = settings.cartUrl || '/cart';
        }
      });
    }

    if (stickybar) {
      var hideUntilSelector = stickybar.getAttribute('data-hide-until') || '.hero';
      var heroEl = document.querySelector(hideUntilSelector);
      if (heroEl) {
        var barIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickybar.classList.toggle('show', !entry.isIntersecting);
          });
        }, { threshold: 0 });
        barIO.observe(heroEl);
      } else {
        stickybar.classList.add('show');
      }
    }
  }

  /* ---------------- variant selection ---------------- */
  function matchVariant(variants, selectedOptions) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (selectedOptions[j] && v.options[j] !== selectedOptions[j]) match = false;
      }
      if (match) return v;
    }
    return null;
  }

  function addWidthParam(url, width) {
    if (!url) return url;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  function initVariantPickers() {
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function (form) {
      var variantScript = form.querySelector('[data-variants]');
      if (!variantScript) return;
      var variants;
      try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var wrapper = form.closest('.product-info') ? form.closest('.product-info').parentElement : form.closest('.product-chapter, .product');
      var priceEl = wrapper ? wrapper.querySelector('[data-price]') : null;
      var wasEl = wrapper ? wrapper.querySelector('.was') : null;
      var imageEl = wrapper ? wrapper.querySelector('.product-image') : null;
      var submitBtn = form.querySelector('button[type="submit"]');

      var optionCount = variants[0] ? variants[0].options.length : 0;
      var selected = new Array(optionCount).fill(null);

      // seed from initially-selected variant
      var initialVariant = variants.filter(function (v) { return String(v.id) === idInput.value; })[0];
      if (initialVariant) selected = initialVariant.options.slice();

      function applyVariant(v) {
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price, settings.moneyFormat);
        if (wasEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            wasEl.style.display = '';
            wasEl.textContent = formatMoney(v.compare_at_price, settings.moneyFormat);
          } else {
            wasEl.style.display = 'none';
          }
        }
        if (imageEl) {
          if (v.featured_image && v.featured_image.src) {
            imageEl.src = addWidthParam(v.featured_image.src, 800);
          } else if (imageEl.dataset.fallbackSrc) {
            imageEl.src = imageEl.dataset.fallbackSrc;
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !v.available;
          submitBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
      }

      form.querySelectorAll('.option-select').forEach(function (select) {
        select.addEventListener('change', function () {
          var pos = parseInt(select.dataset.optionPosition, 10) - 1;
          selected[pos] = select.value;
          applyVariant(matchVariant(variants, selected));
        });
      });

      form.querySelectorAll('.swatches').forEach(function (group) {
        var pos = parseInt(group.dataset.optionIndex, 10);
        var swatches = group.querySelectorAll('.swatch');
        swatches.forEach(function (swatch) {
          if (swatch.dataset.optionValue === selected[pos]) swatch.classList.add('selected');
          swatch.addEventListener('click', function () {
            swatches.forEach(function (s) { s.classList.remove('selected'); });
            swatch.classList.add('selected');
            selected[pos] = swatch.dataset.optionValue;
            applyVariant(matchVariant(variants, selected));
          });
        });
      });

      /* ---------------- AJAX add to cart ---------------- */
      form.addEventListener('submit', function (e) {
        if (settings.cartType === 'page') return; // let it submit normally to /cart
        e.preventDefault();
        var formData = new FormData(form);
        fetch((settings.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              showNotification(data.description || 'Could not add item to cart.');
              return;
            }
            showNotification((data.product_title || data.title) + ' added to cart.');
            updateCartCount();
          })
          .catch(function () {
            showNotification('Something went wrong. Please try again.');
          });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var el = document.querySelector('.cart-count');
        if (el) {
          el.textContent = '(' + cart.item_count + ')';
        } else {
          var cartBtn = document.querySelector('.cart-btn');
          if (cartBtn) {
            var span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = ' (' + cart.item_count + ')';
            cartBtn.appendChild(span);
          }
        }
      });
  }

  var notifyTimeout;
  function showNotification(message) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(notifyTimeout);
    notifyTimeout = setTimeout(function () { el.classList.remove('show'); }, 3200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRailAndSpy();
    initVariantPickers();
  });
})();
